import React from "react";
import { useParams } from "react-router";

import useSegmentActions from "../hooks/useSegmentActions";
import useFirebasePreferences from "../hooks/useFirebasePreferences";
import SegmentForm from "./SegmentForm";

const SegmentCreatePage = () => {
  const { id, order } = useParams();
  const { createSegment } = useSegmentActions();
  const preferences = useFirebasePreferences();
  const degrees =
    preferences && preferences.degrees ? preferences && preferences.degrees : "celsius";

  const handleSubmit = (formValues: any) => {
    createSegment(formValues);
  };

  return (
    <>
      <div className="border rounded-lg overflow-hidden">
        <h2 className="text-xl font-semibold px-4 py-3 bg-muted">
          Create Segment
        </h2>
        <div className="p-4">
          <SegmentForm
            onSubmit={handleSubmit}
            initialValues={{
              firing_id: id,
              order: order,
              degrees: degrees,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SegmentCreatePage;
